import React from 'react';
import { Router, Params, Link, hashHistory } from 'react-router';

import QuestionPage from './question-page.jsx';

const Quiz = React.createClass({
	getInitialState: function() {
		return {
			responses: [],
			currentPage: 1,
			progress: 0,
			buttonLabel: 'Next'
		}
	},
	_updateProgress: function() {
		const totalQuestions = this.props.questions.length;
		const page = this.state.currentPage;

		this.setState({
			progress: (page/totalQuestions*100)
		});
	},
	_updatePage: function() {
		var page = this.state.currentPage;
		page++;

		this._updateProgress();

		if (page <= this.props.questions.length) {
			this.setState({
				currentPage: page
			});
			if (page == this.props.questions.length) {
				this.setState({
					buttonLabel: 'Finish'
				});
			}
		} else {
			this._submitGuess();
		}
	},
	_submitGuess: function() {
		let guessObj = {
			quizId: this.props.id,
			guesses: []
		}

		for (var i = 0; i < this.props.questions.length; i++) {
			guessObj.guesses.push({
				questionId: this.props.questions[i]._id,
				guess: this.state.responses[i]
			})
		}

		let request = new XMLHttpRequest;
		request.open('POST', '/api/v2/quizzes/guesses');
		request.setRequestHeader('Content-Type', 'application/json');
		request.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('token'));
		request.send(JSON.stringify(guessObj));
		request.onreadystatechange = function() {
			if (request.readyState == 4) {
				if (request.status == 201) {
					this.props.getResults(this.props.id);
				} else {
					console.log('error');
				}
			}
		}.bind(this);
	},
	_addResponse: function(val) {
		this.setState({
			responses: this.state.responses.concat(val)
		}, function(){
			this._updatePage();
		});
	},
	_displayQuestions: function() {
		return this.props.questions.map((question) => {
			return (
				<QuestionPage
					key={question._id}
					question={question.question}
					type={question.type}
					choices={question.choices}
					progress={this.state.progress}
					addResponse={this._addResponse}
					buttonLabel={this.state.buttonLabel}
				/>
			)
		})
	},
	render: function() {
		const questions = this._displayQuestions();
		return (
			<div className="view">
				<div className="question-page content">
					{questions[this.state.currentPage - 1]}
				</div>
			</div>
		)
	}
});

export default Quiz;


// WEBPACK FOOTER //
// ./src/views/quiz.jsx